module.exports = __webpack_public_path__ + "assets/img/drawItem2-4cbde575.png";